import React, { useEffect, useState, useCallback, useContext, useMemo } from "react";
import { CircularProgress, Tooltip, IconButton } from "@material-ui/core";
import axios from "axios";
import DataTable from "react-data-table-component";
import Modal from "../../../cm_shared/cm_global_modal";
import CMSyncedVideoPlay from "../../../cm_shared/CMSyncedVideoPlay"
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CustomPagination from "../../../cm_shared/CMCustomPagination";
import CMDeleteModal from "../../../cm_shared/CMDeleteModal";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import CMDownloadDropdown from "../../../cm_shared/CMDownloadDropdown";
import { CloudDownload, LabelImportant } from "@material-ui/icons";
import { pgVisibleLabels } from "../../../../../constants";
import BulkDownloadModal from "../../../cm_shared/CMBulkDownloadPopup";
import { LoadingContext } from "./../../../../../context/spinnerContext"
import AlertBox from "../../../cm_shared/Reporting/AlertBox/AlertComponent"
import VideocamIcon from '@material-ui/icons/Videocam';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@material-ui/core";
import CMLabellingListing from "../../../cm_shared/CM_labelling_listing";
const customStyles = {
  table: {
    style: {
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "200px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};
function PGScenarioLogicalNameListing(props) {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [selectedRows, setSelectedRows] = useState([]);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [approveLoading, setApproveLoading] = useState(false);
  const [approveList, setApproveList] = useState([]);
  const [columns, setColumns] = useState([]);
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [isBulkDownloadPopupOpen, setBulkDownloadPopup] = useState(false);
  const [bulkDownloadRes, setBulkDownloadResp] = useState(null);
  const [statusQuote, setStatusQuote] = useState(null)
  const [modalContent, setModalContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modalSize, setModalSize] = useState(false);
  const [videoUrls, setVideoUrls] = useState([])
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const AlertBoxContainer = useMemo(
    () =>
      statusQuote ? (
        <AlertBox
          text={statusQuote.message}
          severity={!statusQuote.isError} />
      ) : null,
    [statusQuote]
  );
  // const [downloadConfirm, setDownloadConfirm] = useState(false);

  const handleSort = (column, direction) => {
    console.log(column);
    console.log(direction);
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleChange = async (event) => {
    const newRow = event.selectedRows;
    if (scenarioCollectionNew.length === newRow.length || event.allSelected) {
      props.onSelectAllRow(newRow, selectedRows);
    } else if (newRow.length === 0 && !event.allSelected) {
      props.onDeselectAllRow(selectedRows);
    } else if (newRow.length !== selectedRows.length) {
      if (newRow.length < selectedRows.length) {
        const deSelectedArr = selectedRows.filter(
          (obj1) =>
            !newRow.some((obj2) => obj2.scenario_uuid === obj1.scenario_uuid)
        );
        if (deSelectedArr.length > 0) props.onSelectRow(deSelectedArr[0], true);
        else props.onSelectRow(selectedRows[0], true);
      } else newRow.length > 0 && props.onSelectRow(newRow[0]);
    }
    setSelectedRows(event.selectedRows);
  };

  const bulkDownload = async (files) => {
    try {
      setIsLoading(true)
      // setDownloadConfirm(false);
      const payload = files.map((item) => {
        return { file: item.s3_uri };
      });
      const resp = await axios.post(
        process.env.REACT_APP_API_GATEWAY_URL + "/bulk-download",
        payload
      );
      setBulkDownloadResp(JSON.parse(resp.data));
      setBulkDownloadPopup(true);
      // const bulkDownloadRes = JSON.parse(resp.data);
      // if (bulkDownloadRes.statusCode === 200) {
      //   const match = bulkDownloadRes.body.match(/download-(\d+)/);
      //   window.open(`${window.location.origin}/download_archive_list?latestDownload=${match[0]}`, '_blank');
      // }
    } catch (err) {
      console.log('err', err);
    } finally {
      setIsLoading(false)
    }
  };

  const onCloseBulkDownloadPopup = () => {
    setBulkDownloadPopup(false);
    console.log(window.location);
    if (bulkDownloadRes.statusCode === 200) {
      const match = bulkDownloadRes.body.match(/download-(\d+)/);
      window.open(`${window.location.origin}/download_archive_list?latestDownload=${match[0]}`, '_blank');
    }
  }


  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post("/generate-presigned-url", {
      s3_location: filePath,
    });
    window.open(fileToDownload.data.presigned_url);
  };

  const handleModal = (content, sizeVal = false) => {
    console.log("Handle modal", content, sizeVal)
    setModalContent(content);
    sizeVal && setModalSize(sizeVal);
    setIsOpen(true);
  };

  const handleViewLabellingListing = (rowData) => {
    console.log("rowData", rowData);
    handleModal(
      <CMLabellingListing
        labellingDetails={rowData.labelling_details}
        labellingFilesChecked={rowData.labelling_files_checked}
        closeDialog={setIsOpen} />,
      "md",
      true
    )
  }


  const fetchPresignedUrl = async (s3Location) => {
    try {

      const response = await axios.post("/generate-presigned-url", {
        s3_location: s3Location,
      });

      if (response.status === 200 && response.data.presigned_url) {
        return response.data.presigned_url;
      }
    } catch (error) {
      console.error(`Error fetching pre-signed URL for ${s3Location}:`, error);
    }
    return null;
  };

  const handleVideoPlaying = async (rowData) => {
    console.log("rowData", rowData, rowData.avi_files);
    let frontVideo = ""
    let rearVideo = ""
    let rightVideo = ""
    let leftVideo = ""

    rowData.avi_files.forEach((mp4File) => {
      console.log("mp4File", mp4File, mp4File.s3_uri.substr(mp4File.s3_uri.length - 4))
      if (mp4File.s3_uri.substr(mp4File.s3_uri.length - 4) === ".mp4") {
        console.log(mp4File.s3_uri)
        if (mp4File.s3_uri.toLowerCase().indexOf("front") > 0) {
          frontVideo = mp4File.s3_uri
          console.log("inside front", frontVideo)
        }
        if (mp4File.s3_uri.toLowerCase().indexOf("rear") > 0) {
          rearVideo = mp4File.s3_uri
          console.log("inside rear", rearVideo)

        }
        if (mp4File.s3_uri.toLowerCase().indexOf("right") > 0) {
          rightVideo = mp4File.s3_uri
          console.log("inside rear", rightVideo)

        }
        if (mp4File.s3_uri.toLowerCase().indexOf("left") > 0) {
          leftVideo = mp4File.s3_uri
          console.log("inside rear", leftVideo)

        }

      }
    })
    console.log("VIDEOS FOR RENDERING",rowData.scenario_description, frontVideo, leftVideo,rearVideo, rightVideo)

    const [frontUrl, leftUrl, rearUrl, rightUrl] = await Promise.all([
      fetchPresignedUrl(frontVideo),
      fetchPresignedUrl(leftVideo),
      fetchPresignedUrl(rearVideo),
      fetchPresignedUrl(rightVideo),
    ]);

    setVideoUrls({ front: frontUrl, left: leftUrl, rear: rearUrl, right: rightUrl });

    handleModal(
      <CMSyncedVideoPlay
        scenarioName={rowData.scenarioname_with_variation.join("")}
        closeDialog={setIsOpen}
        videoUrls={{ front: frontUrl, left: leftUrl, rear: rearUrl, right: rightUrl }}
      />,
      "lg",
      true
    )
  }

  const initialColumns = [
    {
      name: "Recorded Data",
      selector: "scenario_name",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          {row.scenario_name.includes(".csv")
            ? row.scenario_name.split(".csv")[0]
            : row.scenario_name.split(".zip")[0]}
        </div>
      ),
    },
    {
      name: "Labelling",
      selector: "labelling",
      reorder: true,
      grow: 3,
      cell: (row) => (
        <div style={{ width: "100%", overflowY: 'scroll', height: "100%", ...(!row.labelling ? { display: "flex", justifyContent: "center", alignItems: "center" } : { display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }) }}>
          {!row.labelling ? row.labelling_details :
            Object.keys(row.labelling).filter((key) => pgVisibleLabels.includes(key)
            ).map((key) => {
              if (typeof row.labelling[key] === "object") {
                return row.labelling[key] ?
                  Object.keys(row.labelling[key]).map((childKey) => {
                    return (
                      <>
                        {row.labelling[key][childKey] !== "null" ?
                          <div key={childKey}>
                            <strong>{`${key} ${childKey}`}:</strong> {row.labelling[key][childKey]}
                          </div> : null}
                      </>
                    );
                  }) : undefined
              }
              else {
                return (
                  <>{row.labelling[key] !== "null" ?
                    <div key={key}>
                      <strong>{key}:</strong> {row.labelling[key]}
                    </div> : null}
                  </>
                );
              }
            })}
        </div>

      )
    },

    {
      name: "Recorded At",
      selector: "time_stamp",
      sortable: true,
      reorder: true,
      cell: (row) => {
        return <div>{row.time_stamp}</div>
      }
    },
    {
      name: "Uploaded At",
      selector: "updated_at",
      sortable: true,
      reorder: true,
      cell: (row) => {
        return <div>{row.updated_at}</div>
      }
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: true,
      reorder: true,
      cell: (row) => {
        const isInCart = props.cartItems.some(
          (item) => item.scenario_uuid === row.scenario_uuid
        );
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {row.quality_check_status === "good" ? (
              <Tooltip placement="top" title={<h6>Approve</h6>}>
                <IconButton
                  onClick={() => handleApprove(row.scenario_uuid, "PG")}
                >
                  {approveLoading && approveList.includes(row.scenario_uuid) ? (
                    <CircularProgress size={24} />
                  ) : (
                    <ThumbUpIcon />
                  )}
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title={
                  isInCart ? <h6>Remove from Group</h6> : <h6>Add to Group</h6>
                }
              >
                <IconButton
                  aria-label={isInCart ? "remove" : "add"}
                  onClick={() =>
                    isInCart
                      ? props.handleRemoveFromCart(row)
                      : props.handleAddToCart(row)
                  }
                >
                  {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
                </IconButton>
              </Tooltip>
            )}
            <Tooltip placement="top" title={<h6>Delete</h6>}>
              <IconButton
                aria-label="delete"
                onClick={() => {
                  setDeleteScenarioUuid({
                    scenario_uuid: row.scenario_uuid,
                    scenario_name: row.scenario_name,
                  });
                  setConfirmDeleteOpen(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <CMDownloadDropdown options={[{ label: "Bench Input", Icon: CloudDownload, onClick: () => handleDownload(row.scenario_path) }, {
              label: "MF4", Icon: CloudDownload, onClick: () => handleDownload(row.honda_mf4_s3_uri)
            },
            // {
            //   label: "Videos", Icon: CloudDownload, onClick: () => {
            //     bulkDownload([{ s3_uri: row.scenario_path }, { s3_uri: row.honda_mf4_s3_uri }])

            //     when we get api resonse for avi files
            //     if (row.avi_files && row.avi_files.length) {
            //       bulkDownload(row.avi_files)
            //     }
            //   }
            // }
            ]} />
            {/* <Tooltip placement="top" title={<h6>Download Bench Input</h6>}>
              <IconButton
                disabled={!row.scenario_path || row.scenario_path === null}
                aria-label="download"
                onClick={() => handleDownload(row.scenario_path)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title={<h6>Download MF4</h6>}>
              <IconButton
                disabled={!row.honda_mf4_s3_uri || row.honda_mf4_s3_uri === null}
                aria-label="download"
                onClick={() => handleDownload(row.honda_mf4_s3_uri)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip> */}
            {(!!row.labelling_files_checked && !!row.labelling_files_checked.length) && <Tooltip placement="top" title={<h6>View Labelling File(s)</h6>}>
              <IconButton
                aria-label="view"
                style={{ padding: "7px" }}
                onClick={() => handleViewLabellingListing(row)}
              >
                <LabelImportant />
              </IconButton>
            </Tooltip>}

            {(row.avi_files && row.avi_files.length>0 && row.avi_files.some(file => file.s3_uri.includes('.mp4'))) && (<Tooltip placement="top" title={<h6>Scenario Videos</h6>}>
              <IconButton
                aria-label="view"
                style={{ padding: "7px" }}
                onClick={() => handleVideoPlaying(row)}
              >
                <VideocamIcon />
              </IconButton>
            </Tooltip>)}.
          </div>
        );
      },
    },
  ];

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLogicalFusionData = async () => {
    try {
      const response = await axios.post(
        `/cm/open_loop/list_fusion_data_by_logical_name`,
        {
          scenarioname_with_variation: props.data.scenarioname_with_variation,
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
          searchOptions: props.currentFiltersPassed? props.currentFiltersPassed :{}
        }
      );

      setPreselectedRow(response.data);
      setScenarioCollectionNew(response.data.data);
      setTotal(response.data["total_records"]);
    } catch (error) {
      console.error(error)
      setPreselectedRow({});
      setScenarioCollectionNew([]);
      setTotal(0);
    }
  };

  useEffect(() => {
    fetchLogicalFusionData();
  }, [eventsPerPage, page,sortField,sortOrder]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [props.cartItems, approveLoading]);

  useEffect(() => {
    props.allSelect && props.updateCart(scenarioCollectionNew, "add", true);
  }, [props.allSelect]);

  const setPreselectedRow = (res) => {
    if (props.selectedRows.length > 0) {
      const newSelectedRow = res.data.filter((item) =>
        props.selectedRows.find(
          (obj) => obj.scenario_uuid === item.scenario_uuid
        )
      );
      setSelectedRows(newSelectedRow);
    }
  };
  const handleAddToCart = useCallback((scenario) => {
    props.updateCart(scenario, "add");
  }, []);

  const handleRemoveFromCart = (scenarioId) => {
    props.updateCart(scenarioId, "remove");
  };

  const handleDelete = async (scenarioUuid) => {
    try {
      setStatusQuote(null)
      setIsLoading(true);
      setConfirmDeleteOpen(false);
      const response = await axios.post(`/cm/open_loop/delete-carmaker-pg-scenario-collection`, scenarioUuid);
      fetchLogicalFusionData();
      setStatusQuote({ message: response.data.status_message, isError: false })
    } catch (error) {
      console.error("Failed to delete the scenario:", error);
      if (error && error.response.data.message)
        setStatusQuote({ message: error.response.data.message, isError: true })
      else
        setStatusQuote({ message: "Error Occured", isError: true })
    } finally {
      setIsLoading(false);
      setConfirmDeleteOpen(false);
    }
  };

  const handleApprove = async (scenarioUuid, data_type) => {
    try {
      setApproveList((prevList) => {
        return [...prevList, scenarioUuid];
      });
      setApproveLoading(true);
      await axios.post(`/cm/open_loop/move-file`, {
        scenario_uuid: scenarioUuid,
        delete_flag: "False",
        data_type: data_type,
      });
      fetchLogicalFusionData();
    } catch (error) {
      console.error("Failed to approve the data:", error);
    } finally {
      setApproveList((prevEle) => {
        const newArr = prevEle.filter((ele) => ele !== scenarioUuid);
        return newArr;
      });
      setApproveLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "1rem",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalSize ? modalSize : "sm"}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        heightVal={1000}
      />
      <div
        style={{
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
        }}
      >
        <CustomPagination
          total={total}
          rowsPerPageOptions={rowsPerPageSessionBased}
          eventsPerPage={eventsPerPage}
          page={page}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onPageChange={handlePageChange}
        />
        {columns.length > 0 ? (
          <DataTable
            selectableRows
            selectableRowDisabled={(row) =>
              !row.honda_mf4_s3_uri ||
              !row.scenario_path	 ||
              row.honda_mf4_s3_uri === null ||
              row.scenario_path	 === null
            }
            onSort={handleSort}
            sortServer
            onSelectedRowsChange={handleChange}
            selectableRowSelected={(row) =>
              selectedRows.some((obj) =>
                Object.keys(obj).some((key) => obj[key] === row.scenario_uuid)
              )
            }
            clearSelectedRows={props.clearRows}
            columns={columns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
          ></DataTable>
        ) : null}
      </div>
      {isBulkDownloadPopupOpen && <BulkDownloadModal
        title={"Bulk Download Status"}
        isOpen={isBulkDownloadPopupOpen}
        onClosePopup={onCloseBulkDownloadPopup}
        content={bulkDownloadRes.body}
      />}
      {/* {downloadConfirm && <BulkDownloadConfirmationModal
        isOpen={downloadConfirm}
        onClosePopup={setDownloadConfirm}
        onClickYes={bulkDownload}
      />} */}
      {/* {AlertBoxContainer} */}
      <CMDeleteModal
        open={confirmDeleteOpen}
        message="Are you sure you want to delete this scenario?"
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={() => handleDelete(deleteScenarioUuid)}
      />
      <Dialog
        open={statusQuote}
        onClose={() => setStatusQuote(null)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogContent>
          <DialogContentText id="dialog-description">
            {statusQuote && statusQuote.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusQuote(null)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PGScenarioLogicalNameListing;
